
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import Philosophy from './components/Philosophy';
import CTA from './components/CTA';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <Philosophy />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
